import { render, staticRenderFns } from "./TabOximetryChart.vue?vue&type=template&id=1f50cb3a&scoped=true&"
import script from "./TabOximetryChart.vue?vue&type=script&lang=js&"
export * from "./TabOximetryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f50cb3a",
  null
  
)

export default component.exports